import Flex from "../../../../components/Flex";
import { Box, Paper } from "@mui/material";
import AddSuperBill from "./UpsertSuperBill";
import SuperBillHeader from "./SuperBillHeader";
import PatientDetailsSideSection from "./PatientDetailsSideSection";
import { useGetPatient } from "../../../../queries/use-get-patient-uuid";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePrInvoiceFromClaim } from "./use-pr-invoice-from-claim";

const CreatePRInvoiceLayout = () => {
  const { patientId, claimId } = useParams();

  // Service details, CPT patient-responsibility breakdown, visit and rendering
  // provider all come from the claim this invoice settles. The same hook backs
  // the Invoice listing → Create Invoice → PR flow, so both screens pre-fill
  // identically.
  const { billDetails, visitId, renderingProviderInfo } = usePrInvoiceFromClaim(
    claimId,
    patientId
  );

  const patientValidationFormik = useFormik({
    initialValues: {
      patient: patientId,
    },
    validationSchema: Yup.object({
      patient: Yup.string().required().label("Patient"),
    }),
    enableReinitialize: true,
    onSubmit: () => {},
  });

  const { data: patientData } = useGetPatient(
    patientValidationFormik?.values?.patient
  );
  const [total, setTotal] = useState(0);

  return (
    <Flex height={"calc(100vh - 4.4rem)"} p={1.8}>
      <Flex
        flexDirection={"column"}
        width={"80%"}
        minHeight={"calc(100vh - 60px)"}
        gap={1}
      >
        <Paper
          sx={{
            height: "auto",
            p: 1.2,
            boxSizing: "border-box",
            overflow: "clip",
          }}
        >
          <SuperBillHeader
            patientValidationFormik={patientValidationFormik}
            patientsData={patientData}
            viewBill={false}
            title="Create Invoice for Patient Responsibility"
          />
        </Paper>
        <Box p={0.3} height={"auto"} overflow="auto">
          <AddSuperBill
            patientValidationFormik={patientValidationFormik}
            patientsData={patientData}
            patientDataBillDetails={billDetails}
            viewBill={true}
            totalAmount={total}
            setTotal={setTotal}
            isPatientResponsibilityInvoice={true}
          />
        </Box>
      </Flex>
      <Box width={"20%"} height="inherit">
        <Paper
          sx={{
            height: "inherit",
            p: 1.2,
            boxSizing: "border-box",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PatientDetailsSideSection
            patientsData={patientData}
            viewBill={true}
            total={total}
            visitId={visitId}
            renderingProviderInfo={renderingProviderInfo}
          />
        </Paper>
      </Box>
    </Flex>
  );
};

export default CreatePRInvoiceLayout;
